export enum steps {
  CHANGE = 'auth.updateEmail.steps.step1',
  CONFIRM = 'auth.updateEmail.steps.step2',
}
